// extracted by mini-css-extract-plugin
export default {"icon":"ZiSUrh","innerIcon":"Mj7DAJ"};